import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MngOutComponent } from '@mng/mng-base-ui';
import { KidsAppAvailableStore } from '../kids-buchung-app-available.store';

@Component({
  selector: 'mng-mgs-kids-buchung-ml-info',
  imports: [MngOutComponent],
  templateUrl: './kids-buchung-ml-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KidsBuchungMlInfoComponent {
  readonly buchungAppAvailableStore = inject(KidsAppAvailableStore);
  reservierungMail = this.buchungAppAvailableStore.reservierungMail;
}
